const route = {
	path: '/accouting-definition',
	name: 'accouting-definition',
	meta: {
		title: 'Definiciones Ats',
	},
	component: () => import('@/pages/definitions-ats/page-definitions-ats'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/ats-definitions.js